import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEnter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEnter"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V9H9V3H21V21ZM14 14H10.75V12.5L7.25 15L10.75 17.5V16H16V10H14V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEnter;
